import { Inject, Injectable } from '@angular/core';
import { GapiDAO } from './gapi.dao';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { Observable } from 'rxjs/Observable';
import { APP_CONFIG } from '../config';
import { ReservationRateRulesDataValidator } from './validators/data.validators';
import { DefaultRetryHandler } from './handlers/retry.handlers';
import { HttpClient } from '@angular/common/http';
import { LogService } from '../services/logging.service';

const CLASS_NAME = 'ReservationRateRulesDao';

@Injectable()
export class ReservationRateRulesDao extends GapiDAO {
  constructor(http: HttpClient, @Inject(APP_CONFIG) appConfig: IAppConfig, log: LogService) {
    super(CLASS_NAME, http, appConfig, appConfig.guestApiRules, new DefaultRetryHandler(), new ReservationRateRulesDataValidator(), log);
  }

  get(reservationNumber: string, lastName: string, hotelCode: string): Observable<any> {
    const url = this.daoConfig.url
      .replace('{country}', this.appConfig.country)
      .replace('{language}', this.appConfig.language);
    return super.doGet(url, { confNumber: reservationNumber, hotelCode: hotelCode, lastName: lastName });
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/reservation.rate.rules.dao.ts